// extracted by mini-css-extract-plugin
export default {"iframe":"t1VE2w","fillAllSpace":"MK7jdH","absolute":"N7o80x"};